var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import eventemitter3 from 'eventemitter3';
export const trackingEvents = [
    'consent',
    'trackProduct',
    'trackCartCheckout',
    'trackCart',
    'trackList',
    'trackPageView',
    'trackExperiment',
    'trackUser',
    'trackLogin',
    'trackRegister',
    'trackAddToWishList'
];
export function createServerTracker({ currency, useArticleNumberAsId, pixelId, token }) {
    const defaults = {
        useArticleNumberAsId,
        currency,
        pixelId,
        token
    };
    const serverTracker = {
        name: 'server',
        trackProduct(props, context, eventId) {
            fetch(`/_event?event=trackProduct`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId,
                    props,
                    context, location: window.location.href }))
            });
        },
        trackCartCheckout(props, context, eventId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield fetch(`/_event?event=trackCartCheckout`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId, props: { cart: props.cart }, context, location: window.location.href }))
                    });
                }
                finally {
                    props.callback();
                }
            });
        },
        trackCart(props, context, eventId) {
            fetch(`/_event?event=trackCart`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId,
                    props,
                    context, location: window.location.href }))
            });
        },
        trackList(props, context, eventId) {
            fetch(`/_event?event=trackList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId, props: {
                        listName: props.listName,
                        products: props.products.map((product) => ({
                            articleNumber: product.articleNumber,
                            id: product.id,
                            price: product.price,
                            name: product.name,
                            previousPrice: product.previousPrice
                        }))
                    }, context, location: window.location.href }))
            });
        },
        trackPageView(props, context, eventId) {
            fetch(`/_event?event=trackPageView`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId,
                    props,
                    context, location: window.location.href }))
            });
        },
        trackExperiment(props, context, eventId) {
            fetch(`/_event?event=trackExperiment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId,
                    props,
                    context, location: window.location.href }))
            });
        },
        trackUser(props, context, eventId) {
            fetch(`/_event?event=trackUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId,
                    props,
                    context, location: window.location.href }))
            });
        },
        trackLogin(_props, context, eventId) {
            fetch(`/_event?event=trackLogin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    eventId,
                    currency,
                    context,
                    location: window.location.href
                })
            });
        },
        trackRegister(_props, context, eventId) {
            fetch(`/_event?event=trackRegister`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    eventId,
                    currency,
                    context,
                    location: window.location.href
                })
            });
        },
        trackAddToWishList(props, context, eventId) {
            fetch(`/_event?event=trackAddToWishList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(Object.assign(Object.assign({}, defaults), { eventId,
                    props,
                    context, location: window.location.href }))
            });
        }
    };
    return serverTracker;
}
export function trackerRegistry({ config, inServer }) {
    const trackers = [];
    const initialized = false;
    const events = new eventemitter3();
    const registry = {
        on(event, listeners, { name } = {}) {
            return events.on(event.toString(), (...args) => __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield listeners.apply(this, args);
                }
                catch (err) {
                    console.error(`Error triggering ${event}:${name}`, {
                        err
                    });
                }
            }));
        },
        emit(event, props, context, eventId) {
            return events.emit(event.toString(), props, context, eventId);
        },
        add(tracker) {
            if (trackers.find(({ name }) => name === tracker.name)) {
                throw new Error(`Tracker with name "${tracker.name}" is already registered`);
            }
            if (initialized) {
                throw new Error(`Tried adding tracker "${tracker.name}" after trackers already have been initialized.`);
            }
            trackers.push(tracker);
            // Auto-bind built-in events
            trackingEvents.forEach((method) => {
                if (tracker[method]) {
                    registry.on(method, tracker[method], { name: tracker.name });
                }
            });
            if (inServer) {
                return;
            }
            if (!tracker.initBrowser) {
                return;
            }
            if (typeof (config === null || config === void 0 ? void 0 : config.trackingAllowed) === null || !config.trackingAllowed) {
                return;
            }
            const opts = { config, trackerRegistry: registry };
            try {
                tracker.initBrowser(opts);
            }
            catch (err) {
                console.error(`Error ${tracker.name}:initBrowser`, {
                    err,
                    opts
                });
            }
        },
        trackers: () => trackers.flatMap((t) => t.name)
    };
    return registry;
}
//# sourceMappingURL=trackerRegistry.js.map